<template>
  <div class="btb-booker-list">
    <div class="btb-label-lg mb-2">{{ bookerTitle }}</div>
    <!-- <div class="my-3"
      v-for="reservation in reservations"
      :key="reservation.id"
    >
      <b-button variant="outline-info"
        class="px-4" 
        @click="selectReservation(reservation)"
      >
        {{ getDisplayName(reservation.Booker.Person) }}
      </b-button>
    </div> -->
    <b-list-group class="my-3">
      <b-list-group-item button
        v-for="reservation in reservations"
        :key="reservation.id"
        @click="selectReservation(reservation)"
      >
        {{ getDisplayName(reservation.Booker.Person) }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { getDisplayName } from '../utils';

export const BOOKER_SELECT_EVENTS = {
  SELECT: 'Booker:Select',
}

export default {
  props: {
    title: {
      type: String,
    },
    reservations: {
      type: Array
    }
  },
  data () {
    return {
      bookerTitle: 'Please select the name of the person who booked your reservation:',
    }
  },
  methods: {
    getDisplayName,
    selectReservation (reservation) {
      this.$emit(BOOKER_SELECT_EVENTS.SELECT, reservation);
    }
  },
  mounted: function(){
    console.log('I was inside booker select vue');
  }
}
</script>

<style scoped>

</style>